import React from 'react'
import styled, { css, DefaultTheme } from 'styled-components'
import { ReactComponent as Version } from 'icons/version-11.svg'
import { ReactComponent as VersionDeleted } from 'icons/trash-17.svg'
import { VersionType } from './types'

// Types
interface VersionIconProps {
  active?: boolean
  type: VersionType
  revisionIcon: JSX.Element
}

// Styles
const preventSVGShrinkStyles = css`
  /* Prevent SVG from shrink */
  display: flex;
  flex-shrink: 0;
`

interface IconProps {
  status: 'active' | 'inactive' | 'hover'
  alt: string
  theme: DefaultTheme
}

const iconColors = (
  theme: DefaultTheme,
  status: 'active' | 'inactive' | 'hover'
) => {
  return {
    active: theme.colors.primaryTint[100],
    inactive: '#a7a7a7',
    hover: theme.colors.black,
  }[status]
}

export const VersionIconStyled = styled.svg.attrs((props: IconProps) => ({
  role: 'img',
  alt: props.alt,
}))`
  width: 17px;
  color: ${(props: IconProps) => iconColors(props.theme, props.status)};
  ${preventSVGShrinkStyles}
`

const VersionDeletedStyled = styled(VersionDeleted)`
  width: 17px;
  color: ${({ theme }) => theme.colors.silverchalice};
  margin-left: -1px; /* stylelint-disable-line scales/space */
  ${preventSVGShrinkStyles}
`

const VersionIcon = ({ type, revisionIcon }: VersionIconProps) => {
  switch (type) {
    case 'revision': {
      return revisionIcon
    }
    case 'unavailable': {
      return (
        <VersionIconStyled
          as={Version}
          status="inactive"
          alt="unavailable save"
          data-testid="update-icon-unavailable"
        />
      )
    }
    case 'deleted': {
      return <VersionDeletedStyled />
    }
  }
}

export default VersionIcon
